import { Collapse } from '@mui/material';
import { styled } from '@mui/material/styles';

export default styled(Collapse)(() => ({
  '& .MuiCollapse-wrapperInner': { width: '100%' },
}));
